module.exports = "<footer class=\"footer\">\n  <div class=\"container-fluid\">\n    <nav class=\"pull-left\">\n      <ul>\n        <li>\n          <a routerLink=\"/dashboard\"> About </a>\n        </li>\n      </ul>\n    </nav>\n    <div class=\"copyright pull-right\">\n      &copy;\n      {{ test | date : 'yyyy' }}, made with love by\n      <a href=\"https://www.nsi.co.id/geographic-information-system/\" target=\"_blank\">GIS Lab</a>.\n    </div>\n  </div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.component.html
// module id = ./src/app/components/footer/footer.component.html
// module chunks = main